import React, { useEffect, useState } from 'react';
import { TileContainer } from "@vds3/tiles";
import { Title,Body,Micro } from '@vds3/typography'
import { MarginSpacerM, MarginSpacerS } from '../../Checkout/styleTag';
import { useSelector } from 'react-redux';
import { TextLink } from '@vds3/buttons';
import { Modal, ModalTitle, ModalBody } from '@vds3/modals';

const PlanDetails = (props) => {
    const [routerDetails,setRouterDetails] = React.useState(undefined);
    const [phoneDetails,setPhoneDetails] = React.useState(undefined);
    const servicesInCart = useSelector((state) => state.CustomizeOrder?.servicesInCart)
    const {SetDueDate} = useSelector((state)=>state.CheckoutPage);
    const {dueDate, timeSlot} = SetDueDate;
    useEffect(()=>{
        if((props?.getFloatCartResponse?.planDetails?.otherServices && props?.getFloatCartResponse?.planDetails?.otherServices.length) || (props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length)){
            let getRentRouter = props?.getFloatCartResponse?.planDetails?.otherServices.find((item)=>String(item?.Product).toLowerCase().includes('router'));
             if(props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length){
                getRentRouter = props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.find((item)=>String(item?.type).toUpperCase().includes('NONBDV')&&String(item?.offerName).toUpperCase().includes('ROUTER'));
                getRentRouter = {...getRentRouter,Product:getRentRouter?.offerName}
            }
            setRouterDetails({...getRentRouter,planName:String(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName).split('-')[0]});
        }else{
            if(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName){
                setRouterDetails({Product:"Your own router: Use",planName:String(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName).split('-')[0]});
            }
        }
        if(props?.getFloatCartResponse?.planDetails?.phoneInfo && props?.getFloatCartResponse?.planDetails?.phoneInfo?.noOfLines){
            let equipment = []
            if(props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length){
                equipment = props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.filter((item)=>String(item?.type).toUpperCase().includes('BDV'));
            }
            setPhoneDetails({...props?.getFloatCartResponse?.planDetails?.phoneInfo,equipment})
        }
    },[])

    return (
        <div>
            {servicesInCart!=="BDV"?<><PlanTab routerDetails={routerDetails} dueDate={dueDate} timeSlot={timeSlot}/>
            <MarginSpacerM/></>:<></>}
            {servicesInCart!=="DATA"?<PhoneTab phoneDetails={phoneDetails}/>:<></>}
        </div>
    );
};


const PlanTab = ({routerDetails,dueDate,timeSlot})=>{
    const [openModal,setOpenModal] = useState(false)
    const  closeModal = (modal) => {
        setOpenModal(modal)
    }
    let date = new Date(dueDate);
    let month = date.toLocaleString('default', { month: 'long' });
        let dates=date.getDate();
    if(routerDetails){
        const splitDetails = routerDetails?.Product?.split(':');
        return(
        <div>
            {openModal?<RouterDetailModal openModal={openModal} closeModal={(val)=>closeModal(val)}/>:<></>}
            <TileContainer
                padding='24px'
                aspectRatio='1:1'
                height="175px"
                id="tile-cont-confim"
                >
               <div className='tile-con-tab-confirm'>
                <div style={{width:'124px'}}>
                    <img src="images/CrownRouter.png" width={'100px'} height={'124px'} />
                </div>
                <div>
                    <Micro color="#6F7171">Router</Micro>
                    <Title size="medium" bold>{splitDetails?.[1] || ""} {splitDetails?.[0] || ""}</Title>
                    <MarginSpacerS/>
                    <Body size="large">Installation date</Body>
                    <Body size="large">{`${month} ${dates}, ${timeSlot.split("and")?.[0]} - ${timeSlot.split('and')?.[1]} `}{<TextLink onClick={()=>setOpenModal(true)} type="standAlone" surface="light" disabled={false}>Details</TextLink>}</Body>
                    <MarginSpacerM/>
                    <Micro color="#6F7171">Internet plan</Micro>
                    <Title size="medium">{routerDetails?.planName}</Title>
                </div>
               </div>
            </TileContainer>
        </div>
    )
    }else return <></>
}

const PhoneTab = ({phoneDetails})=>{
    const equipmentName = []
    if(phoneDetails&&phoneDetails?.equipment&&phoneDetails?.equipment.length){
        phoneDetails.equipment.map(data=>{
            if(String(data['offerName']).split('(')[0]!="Business Digital Voice Shipping ")
            equipmentName.push(String(data['offerName']).split('(')[0])
        })
    }
    if(phoneDetails){
        return(
        <div>
            <TileContainer
                padding='24px'
                aspectRatio='1:1'
                height="175px"
                id="tile-cont-confim"
                >
               <div className='tile-con-tab-confirm'>
                <div style={{width:'124px'}}>
                    <img src="images/img_w56P.png" width={'124px'} height={'124px'} />
                </div>
                <div>
                    <Micro color="#6F7171">Desktop phone</Micro>
                    <Title size="medium" bold>{equipmentName.join()}</Title>
                    <MarginSpacerM/>
                    <Micro color="#6F7171">Phone lines</Micro>
                    <Title size="medium">{phoneDetails?.noOfLines} lines</Title>
                </div>
                
               </div>
            </TileContainer>
        </div>
    )
    }else return <></>
}

const RouterDetailModal =({openModal,closeModal})=>{
    return (
        <Modal
            ariaLabel=""
            opened={openModal}
            onOpenedChange={closeModal}
            disableOutsideClick={true} disableFocusLock= {true} 
        >

            <ModalTitle><Title size="small" primitive="h1">Prepare for your installation</Title>

            </ModalTitle>
            <ModalBody>

                <Body size="medium" primitive="h2">
                    Your technician will arrive at the time and date you selected.
                </Body>
                <br />
                <Body size="medium" primitive="h2">
                    An adult 18 years old or older must be present during the installation.
                </Body>
                <br />
                <Body size="medium" primitive="h2">
                    Provide access to the Telco room in your building, if applicable.
                </Body>
                <br />
                <Body size="medium" primitive="h2">
                    Ensure you have permission for this installation with your landlord.
                </Body>
                <br />
                <Body size="medium" primitive="h2">
                    Ensure there will be electricity connected in your business address on the day of the installation.
                </Body>
                </ModalBody>
        </Modal>
    )
}

export default PlanDetails;